import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';

export default function checkPromotion(params) {
    const { id, code, baseUrl, brandId, country, uberToken, clientId, clientSecret, additionalHeaders = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of checkPromotion()');
    invariant(brandId, 'brandId is a required param of checkPromotion()');
    invariant(country, 'country is a required param of checkPromotion()');
    invariant(uberToken, 'uberToken is a required param of checkPromotion()');
    invariant(clientId, 'clientId is a required param of checkPromotion()');
    invariant(id || code, 'id or code is required param of checkPromotion()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };

    const body = JSON.stringify({ promoId: id, promoCode: code });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/promotion/check`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'POST', body }), uberToken, clientId, clientSecret),
        'checkPromotion',
    );
}
